import React from "react";
import { Dropdown, ResponsiveMode } from "@fluentui/react";
import { TgkTextSource } from "../../interfaces/CoObject";
import { ObjectPanelTabs } from "../co-panel/ObjectPanelComponent";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { DbApplicationDropDown } from "../DbApplicationDropdown";
import useCoObjectSourceTextPanel, { DatasetDropdownOption } from "./CoObjectSourceTextPanelHook";
import { DatasetField } from "../../../api/models/dataset-field";

export interface CoObjectSourceTextProps {
  objectSource: TgkTextSource;
  datasetFields?: DatasetField[];
  updateCoObjectSourceText: (obj: TgkTextSource, tabValid, modified: boolean) => void;
  isEdit: boolean;
  isLocked: boolean;
  isComponentInstance: boolean;
  tab: ObjectPanelTabs;
}

export const CoObjectSourceTextPanel: React.FunctionComponent<CoObjectSourceTextProps> = (props) => {
  const {
    objectSource,
    selectDbComboBox,
    analyticalWorkspaceOptions,
    handleOnChangeAnalyticalWorkspace,
    datasetOptions,
    handleOnChangeDataset,
    richTextOptions,
    handleOnChangeRichText,
    isComponentInstance,
    isLocked,
  } = useCoObjectSourceTextPanel(props);

  return (
    <>
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <DbApplicationDropDown
              disabled={isComponentInstance || isLocked}
              dbApplication={objectSource?.dbApplication}
              selectDbComboBox={selectDbComboBox}
            />
          </div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <Dropdown
              id="analytical_workspace_dropdown"
              placeholder={formatMessage(
                analyticalWorkspaceOptions == null ||
                  (analyticalWorkspaceOptions.length == 0 && objectSource?.dbApplication)
                  ? `cof.createnewobject.analyticalworkspace.noavailable`
                  : "cof.base.select"
              )}
              label={formatMessage("cof.createnewobject.analyticalworkspace")}
              options={analyticalWorkspaceOptions}
              selectedKey={objectSource?.analyticalWorkspace?.code ?? null}
              onChange={(_event, selectedOption) => handleOnChangeAnalyticalWorkspace(selectedOption ?? undefined)}
              responsiveMode={ResponsiveMode.large}
              disabled={!objectSource?.dbApplication?.id || isComponentInstance || isLocked}
              required
            />
          </div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <Dropdown
              id="dataset_dropdown"
              placeholder={formatMessage(
                datasetOptions == null || (datasetOptions.length == 0 && objectSource?.analyticalWorkspace?.code)
                  ? `cof.createnewobject.dataset.noavailable`
                  : "cof.base.select"
              )}
              label={formatMessage("cof.createnewobject.dataset")}
              options={datasetOptions}
              selectedKey={objectSource?.dataset?.code ?? null}
              onChange={(_event, selectedOption: DatasetDropdownOption) =>
                handleOnChangeDataset(selectedOption ?? undefined)
              }
              responsiveMode={ResponsiveMode.large}
              disabled={!objectSource?.analyticalWorkspace || isComponentInstance || isLocked}
              required
            />
          </div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <Dropdown
              id="rich_text_dropdown"
              placeholder={formatMessage(
                richTextOptions == null || (richTextOptions.length == 0 && objectSource?.dataset?.code)
                  ? `cof.createnewobject.richtext.noavailable`
                  : "cof.base.select"
              )}
              label={formatMessage("cof.createnewobject.richtext")}
              options={richTextOptions}
              selectedKey={objectSource?.richText?.id ?? null}
              onChange={(_event, selectedOption) => handleOnChangeRichText(selectedOption ?? undefined)}
              disabled={!objectSource?.dataset || isComponentInstance || isLocked}
              responsiveMode={ResponsiveMode.large}
              required
            />
          </div>
        </div>
      </div>
    </>
  );
};
